import { Route, Routes } from "react-router-dom";
import "./App.css";
import Presets from "./components/presets/Presets";
import Footer from "./components/Shared/Footer";
import Navigation from "./components/Shared/Navigation";
import AuthProvider from "./contex/AuthProvider";
import CartProvider from "./contex/CartProvider";
import Auth from "./pages/Auth";
import CreateProject from "./pages/CreateProject";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import RequireAuth from "./router/RequireAuth";

function App() {
  return (
    <div>
      <CartProvider>
        <AuthProvider>
          <Navigation />
          <div className=" md:px-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/project" element={<CreateProject />} />
              <Route path="*" element={<NotFound />} />

              <Route
                path="/presets"
                element={
                  <RequireAuth>
                    <Presets />
                  </RequireAuth>
                }
              />
            </Routes>
          </div>
        </AuthProvider>
      </CartProvider>
      <Footer />
    </div>
  );
}

export default App;
